export default "__VITE_ASSET__CH5OWYjc__"